'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'サービスは現在ご利用いただけません。後ほどもう一度お試しください。',
    NEED_ACTIVE: 'お客様のアカウント {{account}}は、このウェブサイトのご利用は初めてです。 有効化を完了するために、 {{activeLink}} をしたあと、このページに戻って手続きを続けてください',
    GOTO_ACTIVE: '今すぐ有効化',
    NOT_ACTIVED: 'アカウントを有効化することはできませんでした。完了するために {{activeLink}}をしてください',
    COMPLETE_ACTIVE: '有効化の確認',
    FORBID_ACTIVE: 'このアカウントはAliExpressによってサポートされていません！',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: '別のアカウントでログインして下さい',
    ACTIVE_PAGE: 'アカウント有効化のページへの移動'
};